<template>
  <v-row>
    <v-col cols="6">
      <validation-provider
        :vid="uuid()"
        name="Base Type"
        rules="required"
        v-slot="{ errors }"
      >
        <v-select
          label="Base Type"
          :items="baseTypes"
          v-model="dataType.baseType.name"
          @change="save"
        ></v-select>
        <span class="validation-message">{{ errors[0] }}</span>
      </validation-provider>
    </v-col>

    <v-col cols="6">
      <v-text-field
        label="Initial Value"
        v-model="dataType.initialValue"
        @change="save"
      ></v-text-field>
    </v-col>
  </v-row>
</template>

<script>
import { ValidationProvider } from "vee-validate";
import uuid from "src/mixins/uuid";

import { find } from "lodash";

export default {
  name: "DataTypeDirectly",
  props: ["tempId"],
  components: { ValidationProvider },
  mixins: [uuid],
  data() {
    return {
      baseTypes: [
        "BOOL",
        "SINT",
        "INT",
        "DINT",
        "LINT",
        "USINT",
        "UINT",
        "UDINT",
        "ULINT",
        "REAL",
        "LREAL",
        "TIME",
        "DATE",
        "TOD",
        "DT",
        "STRING",
        "BYTE",
        "WORD",
        "DWORD",
        "LWORD",
      ],
    };
  },
  computed: {
    dataType() {
      return find(this.$store.state.dataTypes, { tempId: this.tempId });
    },
  },
  methods: {
    save() {
      this.$store.dispatch("updateDataType", this.dataType);
    },
  },
};
</script>
